import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Button from 'component/Button/index'
import FormModal from 'component/ircListsSupply/FormModal'
import CloseWithoutSaveModal from 'component/ircListsSupply/CloseWithoutSaveModal'
import UploadModal from 'component/ircListsSupply/UploadModal'
import SideFilterForm from 'component/ircListsSupply/SideFilterForm'
import NewPagination from 'component/pagination/newPagination'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import SuccessModal from 'component/Modal/SuccessModal'
import * as ircActions from 'action/irc'
import FilterIconSVG from 'component/svgComponents/filter'
import SupplyErrorModal from 'component/ircListsSupply/supplyErrorModal'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'
import SizeSelect, {components} from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import SupplyTable from 'component/ircListsSupply/newTable'
import 'component/ircListsSupply/newTable.css'
import { ViewModalContainer } from 'component/ircListsSupply/ViewModalV2'
import { SyncModalContainer } from 'component/ircListsSupply/SyncModal'



class IrcListsSupply extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    fetchIrcSupplyList: PropTypes.func.isRequired,
    ircList: PropTypes.array.isRequired,
    pages: PropTypes.number.isRequired,
    validateProducts: PropTypes.func.isRequired,
    isUserMatriz: PropTypes.bool.isRequired,
    saveIrcSupplyList: PropTypes.func.isRequired,
    excludeSupplyList: PropTypes.func.isRequired,
    fetchPositions: PropTypes.func.isRequired,
    error: PropTypes.object,
    user: PropTypes.object.isRequired,
    
  }

  state = {
    sideFilterVisible: false,
    storeMatriz: '999',
    userMatriz: false,
    currentItem: false,
    newValues: false,
    csvFile: false,
    showProcessingModal: false,
    syncModal: {render:false, details: null},
    showEditModal: false,
    showUploadModal: false,
    errorSaveModal: false,
    successModalMsg: false,
    errorExcludeModal: false,
    errorExcludeModalDs: "",
    fileError: false,
    filterValues: {},
    errorModal: { render: false, details: null },
    closeWithoutSaveModal: false,
    closeWithoutSaveEditModal: false,
    maxDays: 5,
    missionsSelectBranchs: [],
    orderByAsc: false,
    page: 0,
    pages: 0,
    limit: 10,
    optionSize: 10,
  }

  handleOrderByAsc = (byAsc) => {
      this.setState({orderByAsc: byAsc}, () => this.handleFetchIrcSupplyList())
  }

  componentDidMount() {
    const periodPositionMaxDaysParam = {
      dsKey: "irc.supply.period.position.max.days",
      nuParameter: 1
    }

    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }

    this.getPeriodPositionMaxDays(periodPositionMaxDaysParam)
    this.getParameter(params).then(resp => {
      const missions = resp.data.split(",")
      this.setState({missionsSelectBranchs: missions}, () => {
        this.handleFetchIrcSupplyList()
      })
     })
    
  }

  componentDidUpdate(prevProps, prevState) {

    if(prevState.optionSize !== this.state.optionSize) {
      this.setState({page: 0}, () => this.handleFetchIrcSupplyList())
    }
  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
    
  }

  handleFetchIrcSupplyList = (resetPage = false) => {
    const {orderByAsc, filterValues, page, optionSize} = this.state
    const today = moment()
    const oneMonthForward = moment().add(1, "month")
    const dtBegin = today.format("L")
    const dtEnd = oneMonthForward.format("L")
    const {
      auth: {user},
      fetchIrcSupplyList
    }  = this.props

    const hasFilters = Object.keys(filterValues).length !== 0

    if(!hasFilters) {
      const defaultFilters = {
        dtBegin,
        dtEnd,
        page,
        size: optionSize,
        ascOrder:orderByAsc
      }

      fetchIrcSupplyList(user.dsToken, defaultFilters)
    }

    else {
      const newFilters = {...filterValues}
      newFilters.page = resetPage ? 0 : page
      newFilters.size = optionSize
      newFilters.dtBegin = filterValues.dtPeriod[0].format("L")
      newFilters.dtEnd = filterValues.dtPeriod[1].format("L")
      const branchs = this.formatBranchs(filterValues.idBranch)
      newFilters.idBranchs = branchs
      newFilters.ascOrder =  orderByAsc
      fetchIrcSupplyList(user.dsToken, newFilters)
      
    }

  }

  formatBranchs(branchList) {
    let branchs = []

    for (const b of branchList) {
      if (b.idBranches) {
        branchs.push(...b.idBranches)
      } else {
        branchs.push(b.value)
      }
    }
    branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)

    return branchs
  }

  getPeriodPositionMaxDays(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values, "")
    .then(resp => {
      this.setState({maxDays: parseInt(resp.data,10) || 5})
    })

  }
  // handleFetchIrcList = (page = 1) => {
  //   const {
  //     auth: { user },
  //     fetchIrcList,
  //   } = this.props
  //   const { filterValues } = this.state
  //   const [dtBegin, dtEnd] = filterValues.dtPeriod || [null, null]

  //   fetchIrcList(user.dsToken, page, {
  //     ...(filterValues.status && { status: filterValues.status }),
  //     ...(filterValues.branchs && { branchs: [filterValues.idBranch] }),
  //     ...(dtBegin && { dtBegin: dtBegin.format() }),
  //     ...(dtEnd && { dtEnd: dtEnd.format() }),
  //     ...(filterValues.status === '2' && { status: '' })
  //   })
  // }
  onExclude = async (cdProcess, closeModalCb) => {
    const {
      auth: { user },
      excludeSupplyList,
    } = this.props
    
    try {
        const response = await excludeSupplyList(user.dsToken, cdProcess)
        
        if(response.cdStatus !== 200) {
          this.setState({errorExcludeModal: true, errorExcludeModalDs: response.data})
        }

        else {
          this.setState({
            successModalMsg: "Programação da lista cancelada com sucesso!",
            csvFile: false,
          })
        }

    }
    catch(error) {
      console.log("error: ", error.data)
      this.setState({errorExcludeModal: true, errorExcludeModalDs: error.data})
    }
    finally {
      closeModalCb()
    }
  }

  onSubmit = async (values) => {
    const {
      auth: { user },
      saveIrcSupplyList,
      translate,
    } = this.props

    const storageBinList = []
    values.positions.forEach((value => {
      const transformPosition = value.position.map((pos => ({warehouseType: value.deposit, storageBinId: pos.value})))
      transformPosition.forEach(v => storageBinList.push(v))
    }))
    values.storageBinList = storageBinList
    try {

      await saveIrcSupplyList(user.dsToken, values)
      this.setState({
        successModalMsg: values.upload ? translate('irc.temporary.list.success') : translate('new.irc.list.success'),
        csvFile: false,
      })
    } catch(error) {

      this.setState({
        errorSaveModal: true,
        errorModal: { render: true,  isUpload: false, dsMessage: error.message.dsMessage}
      })
    }
  }
  
  getSize(size) {
    this.setState({optionSize: size})
  }

  onSubmitCsvList = async (request,callback) => { 
    const {
      auth: { user },
      saveIrcSupplyList,
      translate,
    } = this.props

    try {

      
      await saveIrcSupplyList(user.dsToken, request)
      
      this.setState({
        successModalMsg: request.upload ? translate('irc.temporary.list.success') : translate('new.irc.list.success'),
        csvFile: false,
      } , () => this.setState({showUploadModal: false}, () => callback()))
    } catch(error) {
      this.setState({
        errorSaveModal: true,
        errorModal: { render: true, dsMessage: error.message.dsMessage, isUpload: true}
      })
    }
    // this.setState({ successModalMsg: "A nova lista de IRC foi salva com sucesso!" })
  }

  handleDelete = async () => {
    const {
      // auth: { user },
      // deleteIrcList,
      translate,
    } = this.props
    // await deleteIrcList(user.dsToken, irc)

    this.setState({ successModalMsg: translate('irc.remove.success') })
  }

  toggleEdit = (show, irc = {}, closeWithoutSaveModal = false, newValues) => {
    this.setState({ showEditModal: show, currentItem: irc, closeWithoutSaveModal, newValues })
  }

  toggleEditModal = (show, closeWithoutSaveEditModal = false) => {
    this.setState({showEditModal: show, closeWithoutSaveEditModal})
  }

  renderEditModal() {
    const {
      translate,
      auth: { user },
      isUserMatriz,
    } = this.props
    const { currentItem, closeWithoutSaveEditModal, showEditModal, newValues , maxDays} = this.state
      if(showEditModal) {

      return (
        <FormModal
          hideModal={closeWithoutSaveEditModal}
          maxDays={maxDays || 5}
          translate={translate}
          user={user}
          edit={currentItem}
          onSubmit={this.onSubmit}
          toggleEdit={this.toggleEditModal}
          isUserMatriz={isUserMatriz}
          newValues={newValues}
        />
      )
      }
  }

  toggleView = (show, irc) => {
    this.setState({ showViewModal: show, currentItem: irc })
  }

  renderViewModal() {
    const {
      translate,
      auth: { user },
    } = this.props
    const { currentItem, showViewModal } = this.state

    if(!showViewModal) return

    return (
        <ViewModalContainer
          translate={translate}
          user={user}
          currentItem={currentItem}
          toggleView={this.toggleView}
          toggleEdit={this.toggleEdit}
          toggleUpload={this.toggleUpload}
        />
      )
    
  }

  toggleUpload = (uploadModal) => {
    this.setState({
      showUploadModal: uploadModal,
      // csvFile: !noFile ? file : false,
      // currentItem: currentItem || (noFile ? file : false),
      // closeWithoutSaveModal,
      // newValues
    })
  }

  renderUploadModal() {
    const {
      translate,
      auth: { user },
      isUserMatriz
    } = this.props
    const { currentItem, showUploadModal, csvFile, newValues, maxDays } = this.state

    if (showUploadModal) {
      return (
        <UploadModal
          maxRange={maxDays || 5}
          translate={translate}
          user={user}
          file={csvFile}
          currentItem={currentItem}
          newValues={newValues}
          toggleUpload={this.toggleUpload}
          onSubmit={this.onSubmitCsvList}
          isUserMatriz={isUserMatriz}
        />
      )
    }
  }

  renderCloseWithoutSaveEditModal = () => {
    const { translate } = this.props
    const { closeWithoutSaveEditModal, currentItem, csvFile, newValues } = this.state

    if (closeWithoutSaveEditModal) {
      return (
        <CloseWithoutSaveModal
          translate={translate}
          currentItem={currentItem}
          newValues={newValues}
          file={csvFile}
          toggleEditModal={this.toggleEditModal}
        />
      )
    }
  }

  renderCloseWithoutSaveModal = () => {
    const { translate } = this.props
    const { closeWithoutSaveModal, currentItem, csvFile, newValues } = this.state

    if (closeWithoutSaveModal) {
      return (
        <CloseWithoutSaveModal
          translate={translate}
          currentItem={currentItem}
          newValues={newValues}
          file={csvFile}
          toggle={this.toggleUpload}
        />
      )
    }
  }

  toggleProcessing = (show, irc = false) => {
    this.setState({ showProcessingModal: show, currentItem: irc })
  }

  onFilter = (values) => {
    const newValues  ={ ...values}
    newValues.orderByAsc = this.state.orderByAsc
    this.setState({ sideFilterVisible: false, filterValues: values }, () => {
      this.setState({page: 0})
      this.handleFetchIrcSupplyList(true)
    })
  }

  renderSideFilterForm() {
    const { translate, auth, isUserMatriz } = this.props
    const { sideFilterVisible } = this.state

    return (
      <SideFilterForm
        show={sideFilterVisible}
        closeFilter={() => this.setState({ sideFilterVisible: false })}
        onSubmit={this.onFilter}
        translate={translate}
        auth={auth}
        isUserMatriz={isUserMatriz}
      />
    )
  }

  validateCsv(e) {
    let valid = false

    if (e.length > 0) {
      const file = e[0]
      let ext = (file.name || '').split('.')
      ext = ext[ext.length - 1].toLowerCase()
      if (ext !== 'csv') {
        this.setState({
          errorModal: { render: true, details: 'upload.error.details.ext' }
        })
      } else if (file.size > 5 * 1024 * 1024) {
        this.setState({
          errorModal: { render: true, details: 'upload.error.details.size' }
        })
      } else {
        valid = true
      }
    }

    if (!valid) {
      this.setState({ fileError: true }, () => {
        this.setState({ fileError: false })
      })
    }

    return valid
  }

  toggleSyncModal = () => {
    const resetSyncModal = {render: false, currentItem:null}
    this.setState({syncModal: resetSyncModal})
  }

  renderSyncModal = () => {
    const {translate} = this.props
    const {syncModal} = this.state

    if (syncModal.render) {
      return (
        <SyncModalContainer
          translate={translate}
          currentItem={syncModal.details}
          toggleView={this.toggleSyncModal}
        />
      )
    }
  }

  handleSyncModal = (render, item) => {
    const syncModal = {render, details: item}
    this.setState({syncModal})
  }

  renderErrorExcludeModal = () => {
    const {translate} = this.props
    const {
      errorExcludeModal,
      errorExcludeModalDs
    } = this.state

    if(errorExcludeModal) {
      return (
        <SupplyErrorModal
          className="irc-supply-error-modal"
          center
          size='sm'
          t={translate}
          handleClose={() => this.setState({
            errorExcludeModal: false, })}
          msg={"Houve um erro cancelar a programação da lista"}
          details={errorExcludeModalDs}
        />
      )

    }

  }
  
  renderErrorModal = () => {
    const { translate } = this.props
    const {
      errorSaveModal,
      errorModal: {  isUpload = false, dsMessage}
    } = this.state

    if(errorSaveModal) {
      return (
        <SupplyErrorModal
          className="irc-supply-error-modal"
          center
          size='sm'
          t={translate}
          handleClose={() => this.setState({
            errorSaveModal: false,
          }, () => this.handleFetchIrcSupplyList())}
          msg={!isUpload ? "Houve um erro ao tentar salvar a lista de posições, tente novamente" : "Houve um erro ao fazer o upload do arquivo."}
          details={translate(dsMessage)}
        />
      )

    }
 
  }

  renderNewPagination = () => {
    const {ircList,translate} = this.props
    const {optionSize} = this.state
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]


    const countItems = () => {

      if(ircList.number + 1 === 1) return 1

      return (((ircList.number + 1) - 1) * optionSize) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if(!(ircList.content ?? []).length) return

    return (
    <Row className="new-relatory-row stock-transfer-pagination" >
                      <Col className="align-center margin-bottom ">

                      <NewPagination
                      navClass='pagination new-relatory'
                      count={ircList.totalElements}
                      current={ircList.number + 1}
                      getPage={(page) => this.setState({page: page - 1}, () => this.handleFetchIrcSupplyList())}
                      pages={ircList.totalPages}
                    />

                    <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
                            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
                            <Col xs={4}>
                              <SizeSelect
                              components={{DropdownIndicator}}

                                isSearchable={false}
                                styles={colourStyles}
                                classNamePrefix='react-select'
                                onChange={(option) => {
                                  this.setState({optionSize: option.value})
                                  
                                }}
                                options={PAGINATION_OPTIONS}
                                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                                menuPlacement='top'
                              />
                            </Col>
                      </div>


                      <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
                            <Col >{`
                            ${translate('pagination.size.show')}
                            ${countItems()} - ${(ircList.number + 1) * optionSize > ircList.totalElements ? ircList.totalElements : (ircList.number + 1) * optionSize }
                            ${translate("pagination.size.of")}
                            ${ircList.totalElements}
                            ${translate("pagination.size.items")}`}</Col>

                      </div>

                    </Col>


                  </Row>
    )

  }

  convertSupplyModelToPresenter = (ircSupplyModel) => ({
        dsBranch: ircSupplyModel.idStore,
        inActive: 1,
        inProductsList: 0,
        positionsPerDay: 20,
        dtBegin: ircSupplyModel.dtBegin,
        dtEnd: ircSupplyModel.dtEnd,
        dsListName: ircSupplyModel.listDescription,
        idInventoryCriteria: ircSupplyModel.idIrcSupply,
        positions: [
          ircSupplyModel.storageBinList
        ]
      })

  countItems = () => {
        const {page, optionSize} = this.state
  
        if(page === 1) return 1
  
        return page === 1 ? 1 : ((page - 1) * optionSize) + 1
  }

  render() {
    const {
      translate,
      ircList,
    } = this.props

    const { successModalMsg} = this.state

    return (
      <div className='stock-adjustment'>
        <div className='new-style'>
          <ContentHeader>{translate('irc.lists.supply')}</ContentHeader>

          <div className='new-style-filter'>
            <section className='container-fluid new-upper-container'>
              
              <div className='col-xs-13'>
                <div style={{marginRight:"5px"}} className='float-right'>
                  <Button
                    className='new-button-style btn-primary'
                    text={translate('position.register')}
                    onClick={() => this.toggleEdit(true)}
                  />

                  <Button
                    className='new-button-style'
                    text={"Importar lista"}
                    onClick={() => {this.setState({showUploadModal: true})}}
                  />
                  
                  <Button
                    className='new-button-style'
                    text={translate('mobile.filter')}
                    onClick={() => this.setState({ sideFilterVisible: true })}
                    svgIcon
                    svgComponent={<FilterIconSVG newDesign={false} className=" common-download size-filter-default-svg" /> }
                  />
                </div>
              </div>
            </section>
          </div>

        </div>
          

        <div
            style={{marginTop: "20px"}}
            className='stock-adjustment-table new'
          >
            <div style={{boxShadow: (ircList.content ?? []).length < 1 && 'none'}} className='outer-table stock-transfer-outer-table'>
              { (ircList.content ?? []).length > 0 
              ? 
              <SupplyTable onExclude={this.onExclude} handleSyncModal={this.handleSyncModal}  showViewModal={this.toggleView} ircList={ircList.content || []} translate={translate} handleOrder={this.handleOrderByAsc}  />  
              : 
              <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
                
                <p>Sem resultado de busca</p>
               
              </div>
              }
              {this.renderNewPagination()}
            </div>

        </div>
        {this.renderSideFilterForm()}
        {this.renderViewModal()}
        {this.renderCloseWithoutSaveModal()}
        {this.renderCloseWithoutSaveEditModal()}
        {this.renderEditModal()}
        {this.renderUploadModal()}
        {this.renderErrorModal()}
        {this.renderErrorExcludeModal()}
        {this.renderSyncModal()}
        {successModalMsg && (
          <SuccessModal
            center
            t={translate}
            msg={successModalMsg}
            size='sm'
            handleClose={() => {
              this.setState({ successModalMsg: false })
              this.handleFetchIrcSupplyList()
            }}
            fillButton
            buttonText='OK'
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ auth, ircSupplyReducer, paginateReducer }) => ({
  ircList: ircSupplyReducer.list.records,
  error: ircSupplyReducer.list.error,
  ircSupplyReducer,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  isUserMatriz: auth.isUserMatriz
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ircActions, dispatch)

const IrcListsSupplyTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(IrcListsSupply)

export default connect(mapStateToProps, mapDispatchToProps)(IrcListsSupplyTranslated)

export { IrcListsSupply }
